/**
 * 详情页相关接口
 */

import { post, ApiResponse } from './api';
import { API_PATHS } from './apiPaths';

/**
 * 获取视频详情
 */
export async function getDetail(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.getDetail, body, { params });
}

/**
 * 获取详情页列表（定位与翻页）
 */
export async function getDetailPage(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.getDetailPage, body, { params });
}
